<template>
  <el-dialog
    :title="'开通' + displayName + '会员'"
    :visible.sync="dialogVisible"
    width="480px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="showClose"
    custom-class="amc-purchase-dialog"
    @close="handleClose">
    <div class="purchase-content">
      <!-- 课程信息 -->
      <div class="course-info">
        <div class="course-icon">
          <i class="el-icon-trophy"></i>
        </div>
        <div class="course-detail">
          <h3 class="course-title">{{ displayName }}精品课程会员</h3>
          <p class="course-desc">开通会员解锁全部{{ displayName }}精品课程内容</p>
        </div>
      </div>

      <!-- 课程特点 -->
      <!-- <div class="course-features">
        <div class="feature-item">
          <i class="el-icon-check"></i>
          <span>智能备考计划生成</span>
        </div> -->
        <!-- <div class="feature-item">
          <i class="el-icon-check"></i>
          <span>海量真题练习</span>
        </div> -->
        <!-- <div class="feature-item">
          <i class="el-icon-check"></i>
          <span>AI智能答疑</span>
        </div>
        <div class="feature-item">
          <i class="el-icon-check"></i>
          <span>知识点详解</span>
        </div>
        <div class="feature-item">
          <i class="el-icon-check"></i>
          <span>模拟考试</span>
        </div>
        <div class="feature-item">
          <i class="el-icon-check"></i>
          <span>永久有效</span>
        </div>
      </div>

      <!-- 会员权益 -->
      <div class="member-benefits">
        <div class="benefit-item">
          <i class="el-icon-video-camera"></i>
          <span>{{ displayName }}精品视频课程</span>
        </div>
        <div class="benefit-item">
          <i class="el-icon-document"></i>
          <span>独家学习资料</span>
        </div>
        <div class="benefit-item">
          <i class="el-icon-chat-dot-round"></i>
          <span>专属答疑服务</span>
        </div>
        <div class="benefit-item">
          <i class="el-icon-time"></i>
          <span>永久有效</span>
        </div>
      </div>

      <!-- 价格 -->
      <div class="price-section">
        <div class="price-label">会员价格</div>
        <div class="price-value">
          <span class="currency">¥</span>
          <span class="amount">{{ price }}</span>
        </div>
      </div>

      <!-- 会员状态提示 -->
      <div class="order-info" v-if="isPurchased">
        <el-alert
          title="您已是该课程会员"
          type="success"
          :closable="false"
          show-icon />
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" v-if="showClose">取消</el-button>
      <el-button
        type="primary"
        @click="handlePurchase"
        :loading="loading"
        class="purchase-btn">
        <i class="el-icon-shopping-cart-2" v-if="!loading"></i>
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getMyUserMembership, upsertUserMembership } from '@/api/userMembership'
import { getTokenInfo } from '@/utils/jwtUtils'
import { clearCachedEnabledFeatures } from '@/utils/feature'

export default {
  name: 'AmcPurchaseDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    courseType: {
      type: String,
      default: 'AMC'
    },
    courseLevel: {
      type: String,
      default: ''
    },
    courseDisplayName: {
      type: String,
      default: ''
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      price: '299.00',
      isPurchased: false
    }
  },
  computed: {
    displayName() {
      const dn = (this.courseDisplayName || '').trim()
      if (dn) return dn
      return (this.courseType || '').trim() || 'AMC'
    },
    buttonText() {
      if (this.loading) return '处理中...'
      if (this.isPurchased) return '已开通'
      return '立即开通'
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.checkStatus()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    normalizeMembershipSubjectCode(subjectCode, courseType) {
      const raw = String(subjectCode || '').trim()
      if (!raw) return ''
      const ct = String(courseType || '').trim().toUpperCase()
      const upper = raw.toUpperCase().replace(/\s+/g, '')
      if (ct === 'GESP' || upper.includes('GESP')) {
        const match = upper.match(/LEVEL(\d+)/) || upper.match(/^GESP(\d+)$/) || upper.match(/GESP.*?(\d+)/)
        if (match && match[1]) return `GESPLEVEL${match[1]}`
        return upper.replace(/^CCF-/, '')
      }
      return raw.toUpperCase()
    },
    resolveCourseLevel() {
      const p = (this.courseLevel || '').toString().trim()
      if (p) return this.normalizeMembershipSubjectCode(p, this.courseType)
      const raw = (localStorage.getItem('selectedAmcLevel') || '').toString().trim().toLowerCase()
      if (raw === 'amc10') return 'AMC10'
      if (raw === 'amc12') return 'AMC12'
      return 'AMC8'
    },
    async checkStatus() {
      try {
        const tokenInfo = getTokenInfo()
        if (!tokenInfo || !tokenInfo.id) return

        const lvl = this.resolveCourseLevel()
        const ct = this.courseType || 'AMC'

        const res = await getMyUserMembership({ courseTypeCode: ct, subjectCode: lvl || undefined })
        const membership = (res && res.code === 1) ? res.data : null
        if (membership && String(membership.tierCode || '').toUpperCase() === 'VIP') {
          this.isPurchased = true
          this.$emit('purchased')
          this.dialogVisible = false
        }
      } catch (e) {
        console.error('检查会员状态失败:', e)
      }
    },

    async handlePurchase() {
      if (this.isPurchased) {
        this.$emit('purchased')
        this.dialogVisible = false
        return
      }
      this.loading = true
      try {
        const tokenInfo = getTokenInfo()
        if (!tokenInfo || !tokenInfo.id) {
          this.$message.error('请先登录')
          this.loading = false
          return
        }

        const lvl = this.resolveCourseLevel()
        const ct = this.courseType || 'AMC'

        const res = await upsertUserMembership({
          userId: tokenInfo.id,
          courseTypeCode: ct,
          subjectCode: lvl || null,
          tierCode: 'VIP'
        })
        if (res && res.code === 1) {
          this.$message.success(`开通成功！欢迎成为${this.displayName}会员`)
          this.isPurchased = true
          // 清除功能权限缓存，使新会员权限立即生效
          clearCachedEnabledFeatures()
          this.$emit('purchased')
          this.dialogVisible = false
        } else {
          this.$message.error((res && res.msg) || '开通失败，请重试')
        }
      } catch (e) {
        console.error('开通会员失败:', e)
        this.$message.error('开通会员失败，请重试')
      } finally {
        this.loading = false
      }
    },

    handleClose() {
      this.dialogVisible = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.amc-purchase-dialog {
  border-radius: 12px;
}

.purchase-content {
  padding: 10px 0;
}

.course-info {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  color: white;
  margin-bottom: 20px;
}

.course-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.course-icon i {
  font-size: 32px;
}

.course-detail {
  flex: 1;
}

.course-title {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
}

.course-desc {
  margin: 0;
  font-size: 13px;
  opacity: 0.9;
}

.course-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #606266;
}

.feature-item i {
  color: #67c23a;
  font-weight: bold;
}

.price-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #f5f7fa;
  border-radius: 8px;
  margin-bottom: 16px;
}

.price-label {
  font-size: 14px;
  color: #909399;
}

.price-value {
  color: #f56c6c;
}

.price-value .currency {
  font-size: 16px;
}

.price-value .amount {
  font-size: 28px;
  font-weight: 700;
}

.order-info {
  margin-top: 16px;
}

.order-info p {
  margin: 4px 0;
  font-size: 13px;
}

.member-benefits {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 20px;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #606266;
}

.benefit-item i {
  color: #667eea;
  font-size: 16px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.purchase-btn {
  min-width: 140px;
  height: 44px;
  font-size: 16px;
}

.purchase-btn i {
  margin-right: 6px;
}
</style>

<style>
/* 全局样式覆盖 */
.amc-purchase-dialog .el-dialog__header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid #ebeef5;
}

.amc-purchase-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
}

.amc-purchase-dialog .el-dialog__body {
  padding: 20px 24px;
}

.amc-purchase-dialog .el-dialog__footer {
  padding: 16px 24px 20px;
  border-top: 1px solid #ebeef5;
}
</style>
